/* !!!!!!!!!!!!!!!!!!!!!! */
/* !!! GENERATED FILE !!! */
/* !!!!!!!!!!!!!!!!!!!!!! */

import {
  ModuleDoneType,
  ModuleType,
  PlaniraPlanImage,
  type PlaniraTemplate,
} from "../../types";
import { PlanType } from "../../types";
import { PlanTemplateType } from "../template_types";

export const FlowOutdoorSportsDayTemplate: PlaniraTemplate = {
  type: PlanTemplateType.FlowOutdoorSportsDay,

  planType: PlanType.Quickstart,
  suggestedTitles: [
    "Let’s Enjoy Sports in the Great Outdoors!",
    "Outdoor Sports Day Awaits!",
    "Fun and Fitness for Everyone!",
  ],
  title: "Outdoor Sports Day",
  description: "Organize a fun outdoor sports day.",
  longDescription:
    "Gather your community for an exciting sports day! Choose a date, decide on sports activities, and plan refreshments!",
  emoji: "🏅",
  titleHelp: "Change title or choose another:",
  imageType: PlaniraPlanImage.Travel,

  sections: [
    {
      section: {
        isExpandable: false,
        isDraggable: false,
      },
      modules: [
        {
          type: ModuleType.PlanInfo,
          doneType: ModuleDoneType.None,
          title: "Outdoor Sports Day",
          emoji: "🏅",
        },
      ],
    },
    {
      section: {
        title: "Ongoing",
      },
      modules: [
        {
          type: ModuleType.Calendar,
          doneType: ModuleDoneType.Voting,
          title: "When should we hold the outdoor sports day?",
          emoji: "📅",
          completeAction: {
            question: "Decide on sports activities to include?",
            description: "What activities should we focus on during the day?",
            addModules: [
              {
                type: ModuleType.Poll,
                doneType: ModuleDoneType.Voting,
                title: "What sports should we consider?",
                emoji: "⚽",
                completeAction: {
                  question: "Decide on refreshments?",
                  description:
                    "What refreshments should we prepare for the day?",
                  addModules: [
                    {
                      type: ModuleType.Poll,
                      doneType: ModuleDoneType.Voting,
                      title: "What refreshments should we bring?",
                      emoji: "🥤",
                    },
                  ],
                },
              },
            ],
          },
        },
      ],
    },
  ],

  onTemplateComplete: {
    outroTitle: "Let’s Have Fun in the Sun!",
    outroDescription: "Your outdoor sports day plans are set! Enjoy the games!",
  },
};
